import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=282c706d&scoped=true"
import script from "./ButtonSwitch.vue?vue&type=script&lang=ts"
export * from "./ButtonSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=282c706d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c706d",
  null
  
)

export default component.exports